export enum TransitionalCareDateRangeEnum {
    TodayDescription = 'Today',
    Today = 1,
    Last1MonthDescription = 'Last 1 Month',
    Last1Month = 2,
    Last3MonthsDescription = 'Last 3 Months',
    Last3Months = 3,
    Last6MonthsDescription = 'Last 6 Months',
    Last6Months = 4,
    CustomDescription = 'Custom',
    Custom = 5,
}
